import React, { useRef, useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Image } from 'primereact/image';
import axios from 'axios';
import useAppRoot from '../hooks/useAppRoot';
import './DrawPrescription.scss';

const DrawPrescription = ({ visible, product, quotation, productsLen }) => {
    const appRoot = useAppRoot();
    const toast = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const prescriptionsUploadRef = useRef(null);
    const [sending, setSending] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [isImage, setIsImage] = useState(quotation.es_imagen);
    const [idRegistro, setIdRegistro] = useState(quotation.id_registro);
    const [idRegistroCon, setIdRegistroCon] = useState(quotation.id_registro_concentracion);
    const documentLocation = appRoot + '/seguimiento/' + idRegistro + '/documentos/' + idRegistroCon;

    useEffect(() => {
        if (product) {
            setIsImage(product.es_imagen);
            setIdRegistro(product.id_registro);
            setIdRegistroCon(product.id_registro_concentracion);
        } else {
            setIsImage(quotation.es_imagen);
            setIdRegistro(quotation.id_registro);
            setIdRegistroCon(quotation.id_registro_concentracion);
        }

        setIsVisible(visible);
    }, [quotation]);

    const onClose = () => {
        setIsVisible(false);
    };

    const HeaderTemplate = ({ chooseButton }) => {
        return (
            <div>
                <div className="flex-grow-1 d-flex justify-content-between align-items-center pb-3">
                    <div className="text-center">{chooseButton}</div>
                    {productsLen !== 1 && quotation.estado === 'Ingresado' && (
                        <Button
                            className="text-center text-nowrap"
                            label="Borrar receta"
                            icon="pi pi-trash"
                            loading={deleting}
                            onClick={() => onPrescriptionDelete()}
                        />
                    )}
                </div>
            </div>
        );
    };

    const onPrescriptionDelete = async () => {
        const formData = new FormData();
        formData.append('idRegistroConcentracion', idRegistroCon);

        setDeleting(true);
        axios
            .post('/api/delete-prescription', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(() => {
                toast.current.clear();
                toast.current.show({ severity: 'success', detail: 'Receta borrada correctamente.' });
                window.location.reload();
            })
            .catch((exc) => {
                console.log('error', exc);
                toast.current.clear();
                toast.current.show({ severity: 'error', detail: 'Ha ocurrido un error al intentar borrar la receta. Favor intente nuevamente.' });
            })
            .finally(() => {
                setDeleting(false);
            });
    };

    const onPrescriptionSelect = async (event) => {
        const files = event.files;
        const formData = new FormData();

        formData.append('idRegistroConcentracion', idRegistroCon);
        formData.append('quotationId', idRegistro);

        for (const file of files) {
            formData.append('prescriptions[]', file);
        }

        setSending(true);
        axios
            .post('/api/update-prescription', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                toast.current.clear();
                toast.current.show({ severity: 'success', detail: 'Receta actualizada correctamente.' });

                //if (response.data[1]) {
                //    window.location.reload();
                //}

                setIsImage(response.data[0]);
                setReloadKey(Math.random());
                window.location.reload();
            })
            .catch((exc) => {
                console.log('error', exc);
                toast.current.clear();
                toast.current.show({ severity: 'error', detail: 'Ha ocurrido un error al intentar actualizar la receta. Favor intente nuevamente.' });
            })
            .finally(() => {
                setSending(false);
            });
    };

    if (product) {
        if (!product.existe_imagen) {
            return <div className="text-center">Imagen no disponible</div>;
        }
    } else {
        if (!quotation.existe_imagen) {
            return (
                <Dialog visible={isVisible} onHide={onClose} header="Ver Receta" modal style={{ width: '50vw', height: '80vw' }}>
                    <div className="text-center">Imagen no disponible</div>
                </Dialog>
            );
        }
    }

    if (product) {
        return (
            <div className="prescription-modal">
                <Toast ref={toast} position="bottom-right" />
                {quotation.estado === 'Ingresado' && (
                    <div className="draw-prescription">
                        <FileUpload
                            ref={prescriptionsUploadRef}
                            name="prescriptions[]"
                            multiple={false}
                            accept="image/*,application/pdf"
                            headerTemplate={HeaderTemplate}
                            chooseOptions={{ label: 'Cambiar receta', icon: 'pi pi-file-edit', className: 'p-button-secondary' }}
                            onSelect={(e) => onPrescriptionSelect(e)}
                            disabled={sending}
                        />
                    </div>
                )}
                {isImage && <Image key={reloadKey} className="w-100" src={documentLocation} alt="Receta" preview />}
                {!isImage && <iframe key={reloadKey} id="target" src={documentLocation}></iframe>}
            </div>
        );
    } else {
        return (
            <Dialog visible={isVisible} onHide={onClose} header="Ver Receta" modal style={{ width: '50vw', height: '80vw' }}>
                <div className="prescription-modal">
                    <Toast ref={toast} position="bottom-right" />
                    {quotation.estado === 'Ingresado' && (
                        <div className="draw-prescription">
                            <FileUpload
                                ref={prescriptionsUploadRef}
                                name="prescriptions[]"
                                multiple={false}
                                accept="image/*,application/pdf"
                                headerTemplate={HeaderTemplate}
                                chooseOptions={{ label: 'Cambiar receta', icon: 'pi pi-file-edit', className: 'p-button-secondary' }}
                                onSelect={(e) => onPrescriptionSelect(e)}
                                disabled={sending}
                            />
                        </div>
                    )}
                    {isImage && <Image key={reloadKey} className="w-100" src={documentLocation} alt="Receta" preview />}
                    {!isImage && <iframe key={reloadKey} id="target" src={documentLocation}></iframe>}
                </div>
            </Dialog>
        );
    }
};

export default DrawPrescription;
